import { Component, OnInit, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { CommonService } from './common-services/common-service';
import { CompanyService } from './common-services/Company.service';
import { filter } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';


declare let gtag: Function;
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

	constructor(private spinner: NgxSpinnerService, private router: Router, private commonService: CommonService,
		private companyService: CompanyService, private toastr: ToastrService
	) {

		// gc company header implementation --start
		this.process_gc_company_hdr_computation();
		// gc company header implementation --end
	}

	ngOnInit() {

		// subscribe to router events and send page views to Google Analytics 4
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				if (typeof gtag === 'function') {
					gtag('config', 'G-0YVV5QZHZ1', {
						page_path: event.urlAfterRedirects
					});
				}
			}
		});
		// spinner..
		this.spinner.show();

		// hide spinner..
		setTimeout(() => {
			this.spinner.hide();
		}, 1000);

		// services
		// this.commonService.returnRouteBradCrumbsData();
	}

	process_gc_company_hdr_computation() {
		// for GCcompany change from header --start
		//  this.router.events
		// .pipe(filter(e => e instanceof NavigationEnd))
		// .subscribe((event: NavigationEnd) => {

		//   // extract top-level module name
		//   const module = event.urlAfterRedirects
		//     .split('?')[0]
		//     .split('/')[1] || null;

		//   const previous = this.companyService['activeModule$'].value;

		//   // leaving a module → clear its override
		//   if (previous && previous !== module) {
		//     this.companyService.clearModuleCompany(previous);
		//   }

		//   this.companyService.setActiveModule(module);
		// });

		this.router.events
			.pipe(filter(e => e instanceof NavigationEnd))
			.subscribe((event: NavigationEnd) => {

				// 1. Get the full path and remove query params
				const fullPath = event.urlAfterRedirects.split('?')[0];

				// 2. Define segments to exclude (actions and IDs)
				const excluded = ['list', 'search', 'filter', 'edit', 'new', 'crud', 'details', 'view'];

				// 3. Extract and clean segments
				const segments = fullPath.split('/')
					.filter(segment => {
						if (!segment) return false;

						// Exclude CRUD keywords
						if (excluded.includes(segment.toLowerCase())) return false;

						// Exclude Dynamic IDs (Numbers or UUIDs)
						const isId = /^\d+$/.test(segment) || /^[a-fA-F0-9-]{20,}$/.test(segment);
						if (isId) return false;

						return true;
					});

				// 4. Join segments to get the "Clean Module Path" (e.g., "master/activity")
				const activeModulePath = segments.join('/');

				// --- Your GCcompany Logic ---
				const previous = this.companyService['activeModule$'].value;

				// leaving a module → clear its override
				if (previous && previous !== activeModulePath) {
					this.companyService.clearModuleCompany(previous);
				}

				this.companyService.setActiveModule(activeModulePath);
			});
		// for GCcompany change from header -- end
	}

	@HostListener('window:offline', ['$event'])
	onOffline() {
		this.toastr.error("You are offline. Please check your internet connection.", "Connection Lost", {
			disableTimeOut: true,
			closeButton: true
		});
	}

	@HostListener('window:online', ['$event'])
	onOnline() {
		this.toastr.clear();
		this.toastr.success("You are back online.", "Connected", {
			timeOut: 3000
		});
	}
}
